// 페이지 인가 채크
export default function pageAuthorization(requiredAuth, isEvery = false) {
    return ({ next, store, }) => {
        // 유저에게 필수 권한이 있는지 채크
        if (store.getters['user/getterUserPermission'](requiredAuth, isEvery)) {
            return next();
        }
        // 조회 권한 없으면 로그인 페이지
        return next({
            name: 'Login',
        });
    };
}
